import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const LicenseGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',

        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External ID',
        description: '',
        sortable: true,
        // editable: true,
        hide: false,
        width: 120,
    },
    {
        field: 'licensee',
        headerName: 'Licensee',
        description: '',
        sortable: false,
        editable: true,
        width: 150,
    },
    {
        field: 'market',
        headerName: 'Market',
        description: '',
        sortable: false,
        // editable: true,
        width: 200,
    },
    {
        field: 'territory',
        headerName: 'Territory',
        description: '',
        sortable: false,
        // editable: true,
        width: 200,
    },
    {
        field: 'amount',
        headerName: 'raw amount',
        description: '',
        sortable: true,
        editable: true,
        hide: true,
        // editable: true,
        width: 150,
    },
    {
        field: 'displayAmount',
        headerName: 'Amount',
        description: '',
        sortable: true,
        editable: true,
        hide: false,
        // editable: true,
        width: 150,
    },
    {
        field: 'propertyId',
        headerName: 'Property ID',
        sortable: true,
        width: 100,
    },

    {
        field: 'productName',
        headerName: 'Product Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        description: 'This column has a value getter and is not sortable.',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'availBegin',
        headerName: 'Avail Begin',
        description: '',
        sortable: false,
        // editable: true,
        width: 100,
    },
    {
        field: 'availEnd',
        headerName: 'Avail End',
        description: '',
        sortable: false,
        // editable: true,
        width: 100,
    },
    {
        field: 'executionDate',
        headerName: 'Executed',
        description: '',
        sortable: false,
        // editable: true,
        width: 100,
    },
    {
        field: 'runs',
        headerName: 'Runs',
        description: '',
        sortable: false,
        // editable: true,
        width: 100,
        hide: false
    },
    {
        field: 'exhibitionDays',
        headerName: 'Ex Days',
        description: '',
        sortable: false,
        // editable: true,
        width: 100,
        hide: false
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },

];
